import { NamedProperty } from "sprint-common-web";

import { AspectRatio } from "../../../common/data/lookup-data-providers/AspectRatiosDataProvider";
import {
    AspectType,
    EncodeSpecificationItem,
    EncodeSpecificationType,
    FrameratePresets
} from "../context/EncodeSpecificationItem";

export type EncodeSpecificationListingItem = EncodeSpecificationMpeg1ListingItem | EncodeSpecificationMpeg4ListingItem;

interface BaseEncodeSpecificationListingItem {
    id: string;
    name: string;
    updatedDate: Date;
    updatedBy: string;
    targetAspectRatio: AspectRatio;
    isModified?: boolean;
}

export interface EncodeSpecificationMpeg1ListingItem extends BaseEncodeSpecificationListingItem {
    type: EncodeSpecificationType.MPEG_1;
    details: {
        frameratePresets: FrameratePresets;
        aspectType: AspectType;
        slug?: number;
    };
}

export interface EncodeSpecificationMpeg4ListingItem extends BaseEncodeSpecificationListingItem {
    type: EncodeSpecificationType.MPEG_4;
    details: {
        ffmpegCommand: string;
        framerateProfile: NamedProperty;
    };
}

export const mapToEncodeSpecificationListingItem = (item: EncodeSpecificationItem): EncodeSpecificationListingItem => {
    switch (item.type) {
        case EncodeSpecificationType.MPEG_1: {
            return {
                id: item.id,
                name: item.name,
                type: item.type,
                details: {
                    frameratePresets: item.frameratePresets,
                    slug: item.slug,
                    aspectType: item.aspectType
                },
                updatedBy: item.audit.updatedBy,
                updatedDate: new Date(item.audit.updatedDate),
                targetAspectRatio: item.targetAspectRatio,
                isModified: item.isModified
            };
        }

        case EncodeSpecificationType.MPEG_4: {
            return {
                id: item.id,
                name: item.name,
                type: item.type,
                details: {
                    ffmpegCommand: item.ffmpegCommand,
                    framerateProfile: item.framerateProfile
                },
                updatedBy: item.audit.updatedBy,
                updatedDate: new Date(item.audit.updatedDate),
                targetAspectRatio: item.targetAspectRatio,
                isModified: item.isModified
            };
        }

        default:
            throw new Error("Incorrect encode specification type");
    }
};
